<template>
	<div class="slider-card-wrap" :class="{ 'slider-card-wrap--nav': showNavigation }">
		<Swiper
			:slides-per-view="swiperSetting.sliderPerView"
			:space-between="swiperSetting.spaceBetween"
			:centered-slides="swiperSetting.centeredSlides"
			:loop="swiperSetting.loop"
			:breakpoints="swiperSetting.breakpoints"
			:modules="showNavigation ? [SwiperNavigation] : []"
			:navigation="showNavigation ? { nextEl: '.sc-nav-next', prevEl: '.sc-nav-prev' } : false"
		>
			<SwiperSlide v-for="slide in swiperSlides" :key="slide">
				<div class="product-card-slider__item">
                    <Fancybox :options="{}">
                        <a :href="slide.src" data-fancybox>
                            <img :src="slide.src" />
                        </a>
                    </Fancybox>
				</div>
			</SwiperSlide>
		</Swiper>
		<template v-if="showNavigation">
			<button class="sc-nav-prev sc-nav" aria-label="Назад">
				<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><polyline points="15 18 9 12 15 6"/></svg>
			</button>
			<button class="sc-nav-next sc-nav" aria-label="Вперёд">
				<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><polyline points="9 18 15 12 9 6"/></svg>
			</button>
		</template>
	</div>
</template>

<script setup>
import { Navigation as SwiperNavigation } from 'swiper/modules'
import 'swiper/css/navigation'
import Fancybox from '~/components/UI/Fancybox.vue';
const props = defineProps({
    swiperClass: {type: String, default: ""},
    slideClass: {type: String, default: ""},
    slideImageClass: {type: String, default: ""},
    /**
     * @type {SwiperImg[]}
     */
    swiperSlides: {type: Array, required: true},
    needLink: {type: Boolean, default: false},
    showNavigation: {type: Boolean, default: false},
    swiperSetting: {
        type: Object,
        default: (() => {
            return {
                sliderPerView: "1.2",
                spaceBetween: "10",
                loop: false,
                centeredSlides: false,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                breakpoints: {
                    320: {
                        sliderPerView: "1.2",
                        spaceBetween: "10",
                    }
                }
            };
        })
    },
});

let setting = {}

// const openVideoModal = (code) => {
//     this.$emit("openVideoModal", code);
// };
// const openGalleryModal = (item) => {
//     this.$emit("openGalleryModal", item);
// };
onMounted(() => {
    setting = props.swiperSetting
})

</script>

<style scoped>
.slider-card-wrap {
  position: relative;
}
.sc-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: rgba(255,255,255,0.92);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 12px rgba(0,0,0,0.10);
  transition: background 0.18s, opacity 0.18s;
  padding: 0;
}
.sc-nav:hover { background: #fff; box-shadow: 0 4px 18px rgba(0,0,0,0.16); }
.sc-nav svg { width: 20px; height: 20px; color: #1a1a1a; }
.sc-nav-prev { left: 14px; }
.sc-nav-next { right: 14px; }
.sc-nav.swiper-button-disabled { opacity: 0.3; pointer-events: none; }
</style>
